(() => {
  /* Susie's comfort PDP + bundles. Same offer as the homepage bundle builder (mt-product-hero):
     1 tank / 3 tanks (pay 2) / 5 tanks (pay 3). Colour + size are picked INSIDE the selected
     bundle card, one row per tank. Every tank goes in as its own line at the flat variant price;
     the free ones come off automatically (cart shows them at $0, Lasso Rewards at checkout). */
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const product = JSON.parse(root.querySelector('[data-product]').textContent);
    const U = root.dataset.unit || 'tank', Us = root.dataset.units || 'tanks', Ucap = U.charAt(0).toUpperCase() + U.slice(1);
    const swatches = JSON.parse(root.querySelector('[data-swatches]')?.textContent || '{}');
    const form = root.querySelector('.ss-form');
    const img = root.querySelector('.ss-main-image');
    const status = root.querySelector('.ss-form-status');
    const add = form.querySelector('[name="add"]');
    const fine = root.querySelector('[data-bundle-fine]');
    const tierInputs = [...root.querySelectorAll('[data-bundle-input]')];
    const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency: root.dataset.currency || 'USD'}).format(n / 100);
    const colorIndex = Math.max(0, product.options.findIndex(o => /colou?r/i.test(o.name || o)));
    const sizeIndex = product.options.length > 1 ? (colorIndex === 0 ? 1 : 0) : -1;
    const colors = [...new Set(product.variants.map(v => v.options[colorIndex]))];
    const sizes = sizeIndex < 0 ? [] : [...new Set(product.variants.map(v => v.options[sizeIndex]))];
    const find = (color, size) => product.variants.find(v => v.options[colorIndex] === color && (sizeIndex < 0 || v.options[sizeIndex] === size));
    const colorInStock = color => product.variants.some(v => v.available && v.options[colorIndex] === color);
    const thumb = src => src ? src.split('?')[0] + '?width=120' : '';
    const colorImage = color => (product.variants.find(v => v.options[colorIndex] === color && v.featured_image) || {}).featured_image;

    // Starting colour: ?variant= if linked, else the first variant in stock.
    const linked = new URL(location.href).searchParams.get('variant');
    const start = product.variants.find(v => String(v.id) === linked) || product.variants.find(v => v.available) || product.variants[0];
    /* Size starts EMPTY on purpose (homepage does the same): a pre-picked "S" ships the wrong
       size to most of this audience. A size chosen on tank 1 fills every tank not sized by hand
       (homepage test 8b603b32: +6% CVR). */
    let slots = [{color: start.options[colorIndex], size: linked ? start.options[sizeIndex] || '' : '', sized: false}];

    const tier = () => { const i = tierInputs.find(x => x.checked) || tierInputs[0]; return {qty:Number(i?.value || 1), paid:Number(i?.dataset.paid || 1), input:i}; };

    function showPhoto(src, alt, button) {
      img.removeAttribute('srcset'); img.src = src; img.alt = alt || product.title;
      const zoom = root.querySelector('.ss-zoom-dialog img'); zoom.src = src; zoom.alt = img.alt;
      root.querySelectorAll('[data-photo]').forEach(b => b.setAttribute('aria-pressed', b === button ? 'true' : 'false'));
    }
    function showColor(color) {
      const image = colorImage(color);
      if (!image) return;
      const button = [...root.querySelectorAll('[data-photo]')].find(b => b.dataset.photo.split('?')[0] === image.src.split('?')[0]);
      showPhoto(image.src, image.alt || color, button);
      if (button) { const rail = root.querySelector('.ss-thumbs'); rail.scrollTo({left:button.offsetLeft-rail.offsetLeft,behavior:'instant'}); }
    }

    function rowHTML(i, paid, qty) {
      const n = i + 1;
      return `<div class="ss-row" data-row="${i}">
        <img class="ss-row-img" alt="" width="52" height="52" loading="lazy">
        <div class="ss-row-top">
          <span class="ss-row-label">${qty > 1 ? Ucap + ' ' + n : 'Your ' + U}${i >= paid ? '<span class="ss-row-free">FREE</span>' : ''}</span>
          <span class="ss-row-color" data-row-color></span>
        </div>
        ${sizeIndex < 0 ? '' : `<label class="ss-row-size"><span class="ss-sr">Size for ${qty > 1 ? U + ' ' + n : 'your ' + U}</span><select data-row-size><option value="">Select size</option>${sizes.map(s => `<option value="${s.replace(/"/g,'&quot;')}">${s}</option>`).join('')}</select></label>`}
        <div class="ss-row-swatches" role="radiogroup" aria-label="Color for ${qty > 1 ? U + ' ' + n : 'your ' + U}">${colors.map(c => `<button type="button" role="radio" class="ss-row-swatch" data-color="${c.replace(/"/g,'&quot;')}" title="${c.replace(/"/g,'&quot;')}" aria-label="${c.replace(/"/g,'&quot;')}" style="--swatch:${swatches[c] || '#ded5c8'}"></button>`).join('')}</div>
      </div>`;
    }
    function paintRow(row, slot) {
      row.querySelector('[data-row-color]').textContent = slot.color;
      const image = colorImage(slot.color);
      const rowImg = row.querySelector('.ss-row-img');
      if (image) { rowImg.src = thumb(image.src); rowImg.hidden = false; } else rowImg.hidden = true;
      row.querySelectorAll('.ss-row-swatch').forEach(b => {
        const on = b.dataset.color === slot.color;
        b.setAttribute('aria-checked', String(on)); b.tabIndex = on ? 0 : -1;
        b.disabled = !colorInStock(b.dataset.color);
      });
      const select = row.querySelector('[data-row-size]');
      if (select) {
        [...select.options].forEach(o => {
          if (!o.value) return;
          const v = find(slot.color, o.value);
          o.disabled = !v?.available;
          o.textContent = o.value + (v?.available ? '' : ' (sold out)');
        });
        if (slot.size && select.querySelector(`option[value="${CSS.escape(slot.size)}"]`)?.disabled) slot.size = '';
        select.value = slot.size || '';
        select.classList.toggle('is-empty', !slot.size);
      }
      row.classList.remove('is-missing');
    }
    function renderBody() {
      const {qty, paid, input} = tier();
      root.querySelectorAll('[data-tier]').forEach(t => {
        const on = t.contains(input);
        t.classList.toggle('is-active', on);
        const body = t.querySelector('[data-tier-body]');
        body.hidden = !on;
        if (!on) { body.replaceChildren(); return; }
        body.innerHTML = slots.map((_, i) => rowHTML(i, paid, qty)).join('');
        body.querySelectorAll('.ss-row').forEach((row, i) => paintRow(row, slots[i]));
      });
    }
    function renderTotals() {
      const {qty, paid} = tier();
      const base = find(slots[0].color, slots[0].size) || start;
      const unit = base.price;
      const total = unit * paid;
      root.querySelector('[data-cta-total]').textContent = money(total);
      root.querySelector('[data-sticky-price]').textContent = money(total);
      root.querySelector('[data-sticky-selection]').textContent = qty === 1 ? [slots[0].color, slots[0].size].filter(Boolean).join(' / ') : `${qty} ${Us} · ${qty - paid} free`;
      fine.textContent = qty === 1 ? '' : (qty - paid === 1 ? `Your free ${U} is applied automatically. No code needed.` : `Your ${qty - paid} free ${Us} are applied automatically. No code needed.`);
      add.disabled = !product.variants.some(v => v.available);
      root.querySelector('[data-add-label]').textContent = add.disabled ? 'Sold out' : 'Add to cart';
      root.querySelector('[data-cta-total]').hidden = add.disabled;
      const first = find(slots[0].color, slots[0].size);
      form.querySelector('[data-variant-id]').value = first?.id || '';
      if (first) { const url = new URL(location.href); url.searchParams.set('variant', first.id); history.replaceState({},'',url); }
    }
    function setTier() {
      const {qty} = tier();
      while (slots.length < qty) slots.push({color: slots[0].color, size: slots[0].size, sized: false});
      slots.length = qty;
      status.textContent = '';
      renderBody();
      renderTotals();
    }

    tierInputs.forEach(input => input.addEventListener('change', setTier));
    // Row controls (delegated: rows are rebuilt when the bundle changes).
    form.addEventListener('click', e => {
      const b = e.target.closest('.ss-row-swatch');
      if (!b || b.disabled) return;
      const row = b.closest('.ss-row'); const i = Number(row.dataset.row);
      slots[i].color = b.dataset.color;
      paintRow(row, slots[i]);
      showColor(slots[i].color);
      renderTotals();
    });
    form.addEventListener('keydown', e => {
      const b = e.target.closest('.ss-row-swatch');
      if (!b || !['ArrowRight','ArrowLeft','ArrowDown','ArrowUp'].includes(e.key)) return;
      e.preventDefault();
      const list = [...b.parentElement.querySelectorAll('.ss-row-swatch:not(:disabled)')];
      const next = list[(list.indexOf(b) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + list.length) % list.length];
      next.click(); next.focus();
    });
    form.addEventListener('change', e => {
      const select = e.target.closest('[data-row-size]');
      if (!select) return;
      const i = Number(select.closest('.ss-row').dataset.row);
      slots[i].size = select.value;
      if (i === 0) slots.slice(1).forEach(s => { if (!s.sized && find(s.color, select.value)?.available) s.size = select.value; });
      else slots[i].sized = true;
      root.querySelectorAll('[data-tier-body] .ss-row').forEach((row, j) => paintRow(row, slots[j]));
      status.textContent = '';
      renderTotals();
    });

    root.querySelectorAll('[data-photo]').forEach(b => b.addEventListener('click', () => showPhoto(b.dataset.photo,b.dataset.alt,b)));
    let trigger;
    const openDialog = (dialog,button) => { trigger=button;dialog.showModal(); document.documentElement.style.overflow='hidden'; };
    root.querySelectorAll('[data-size-open]').forEach(b => b.addEventListener('click',()=>openDialog(root.querySelector('.ss-size-dialog'),b)));
    root.querySelector('[data-zoom]').addEventListener('click',e=>openDialog(root.querySelector('.ss-zoom-dialog'),e.currentTarget));
    root.querySelectorAll('dialog').forEach(d => {
      d.querySelector('[data-dialog-close]').addEventListener('click',()=>d.close());
      d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}});
      d.addEventListener('close',()=>{document.documentElement.style.overflow='';trigger?.focus({preventScroll:true});});
    });

    form.addEventListener('submit', async e => {
      e.preventDefault(); if(add.disabled) return;
      // Every tank needs a size before anything is added (homepage rule: no partial carts).
      const rows = [...root.querySelectorAll('[data-tier-body]:not([hidden]) .ss-row')];
      const missing = slots.findIndex(s => !find(s.color, s.size)?.available);
      if (missing !== -1) {
        const row = rows[missing];
        row?.classList.add('is-missing');
        const {qty} = tier();
        status.textContent = slots[missing].size ? `${qty > 1 ? Ucap + ' ' + (missing + 1) : 'That size'} is sold out in ${slots[missing].color}. Please pick another size or color.` : `Please select a size${qty > 1 ? ' for tank ' + (missing + 1) : ''}.`;
        row?.scrollIntoView({block:'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        row?.querySelector('[data-row-size]')?.focus({preventScroll:true});
        return;
      }
      add.disabled = true;
      root.querySelector('[data-add-label]').textContent = 'Adding…';
      status.textContent = '';
      let itemAdded = false;
      const items = slots.map(s => ({id: find(s.color, s.size).id, quantity: 1}));
      const count = items.length;
      try {
        const drawer = document.getElementById('cart-drawer');
        if (!drawer) throw new Error('The cart drawer is unavailable. Please refresh and try again.');
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        await customElements.whenDefined('theme-drawer');
        /* A bundle IS the order, same as the homepage: start clean on both sides or
           Lasso appends to its old session (lasso_sid) and a second press stacks tanks.
           The clear must send a body - a bodyless POST gets a 411 and silently fails. */
        try { localStorage.removeItem('lasso_sid'); } catch (err) {}
        try { sessionStorage.removeItem('__lasso_token__'); } catch (err) {}
        await fetch(root.dataset.root + 'cart/clear.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:'{}'}).catch(() => {});
        const sections = [...new Set([...document.querySelectorAll('cart-items-component')]
          .map(element => element.dataset.sectionId).filter(Boolean))];
        const response = await fetch(root.dataset.root + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items, sections:sections.join(','), sections_url:location.pathname})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
        itemAdded = true;
        const cartResponse = await fetch(root.dataset.root + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
        if (!cartResponse.ok) throw new Error('The cart could not be refreshed.');
        const cart = await cartResponse.json();
        const lines = Object.values(items.reduce((acc,i) => { (acc[i.id] ||= {merchandiseId:String(i.id),quantity:0}).quantity++; return acc; }, {}));
        form.dispatchEvent(new CartLinesUpdateEvent({
          action:'add', context:'product', lines,
          promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{
            items:cart.items,source:'susies-comfort-pdp',sourceId:root.id,itemCount:count,
            productId:product.id,sections:result.sections,didError:false
          }})
        }));
        // Let the theme hydrate drawer contents and update its header count before opening.
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        /* 2026-09-25 (owner): skip the drawer, go straight to Lasso checkout. */
        if (typeof window.bbGoLasso === 'function') { status.textContent = 'Taking you to checkout…'; window.bbGoLasso(); return; }
        drawer.open();
        status.textContent = count === 1 ? 'Added to your bag.' : `${count} tanks added to your bag.`;
      } catch(error) {
        if (itemAdded) {
          status.textContent = 'Added to your bag, but the drawer could not refresh. ';
          const link = document.createElement('a');
          link.href = root.dataset.root + 'cart'; link.textContent = 'View your bag';
          status.append(link);
        } else status.textContent = error.message;
      } finally {
        renderTotals();
      }
    });

    const sticky=root.querySelector('.ss-sticky');
    const observer = new IntersectionObserver(entries => {const e=entries[0]; sticky.hidden=e.isIntersecting || e.boundingClientRect.top>0;},{threshold:0});
    observer.observe(form);
    root.querySelector('[data-sticky-buy]').addEventListener('click',()=>{root.querySelector('.ss-buy').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});});
    root.querySelector('.ss-buy').style.scrollMarginTop='24px';
    // Media is loaded and played only while visible. No native video chrome.
    const videos = [...root.querySelectorAll('[data-video-src]')];
    function syncSound(video) {
      const button = video.parentElement.querySelector('[data-video-sound]');
      button.setAttribute('aria-pressed', String(!video.muted));
      button.setAttribute('aria-label', (video.muted ? 'Unmute ' : 'Mute ') + button.dataset.name + "'s video");
    }
    function playVisible(video) {
      if (!video.src) video.src = video.dataset.videoSrc;
      video.play().catch(() => { /* The audio button also retries browser-blocked playback. */ });
    }
    const videoObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const video = entry.target;
        video.dataset.visible = String(entry.isIntersecting);
        if (entry.isIntersecting && !document.hidden) playVisible(video);
        else video.pause();
      });
    }, {threshold:0.2});
    videos.forEach(video => {
      video.muted = true;
      videoObserver.observe(video);
      video.addEventListener('volumechange', () => syncSound(video));
      video.parentElement.querySelector('[data-video-sound]').addEventListener('click', () => {
        const unmute = video.muted;
        videos.forEach(other => { if (other !== video) other.muted = true; });
        video.muted = !unmute;
        syncSound(video);
        playVisible(video);
      });
    });
    const videoRail = root.querySelector('.ss-video-grid');
    root.querySelectorAll('[data-video-step]').forEach(button => button.addEventListener('click', () => {
      const card = videoRail.querySelector('article');
      const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(videoRail).gap || 0);
      videoRail.scrollBy({left: Number(button.dataset.videoStep) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
    const reviews = root.querySelector('.ss-reviews');
    const reviewObserver = new IntersectionObserver(entries => {
      reviews.dataset.offscreen = String(!entries[0].isIntersecting);
    });
    reviewObserver.observe(reviews);
    const visibilityHandler = () => {
      videos.forEach(video => {
        if (!document.hidden && video.dataset.visible === 'true') playVisible(video);
        else video.pause();
      });
    };
    document.addEventListener('visibilitychange', visibilityHandler);
    document.addEventListener('shopify:section:unload', function cleanup(event) {
      if (!event.target.contains(root)) return;
      observer.disconnect(); videoObserver.disconnect(); reviewObserver.disconnect();
      document.removeEventListener('visibilitychange', visibilityHandler);
      document.removeEventListener('shopify:section:unload', cleanup);
    });

    setTier();
    if (linked) showColor(slots[0].color);
  }
  document.querySelectorAll('[data-ss-pdp]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ss-pdp]').forEach(init));
  // A bfcache restore after checkout shows a stale cart; the homepage reloads here too.
  window.addEventListener('pageshow', e => { if (e.persisted) location.reload(); });
})();
